import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo, useEffect, useRef, useState } from "react";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
import { Tooltip } from "./Tooltip";
import { Typography } from "./Typography";
export const overflowingTypographyClasses = {
    root: "MinervaOverflowingTypography-root",
    "line-clamp": "MinervaOverflowingTypography-lineClamp",
};
export const OverflowingTypography = memo((props) => {
    const { children, lineClamp, truncate, hideTooltip, sx, className, ...rest } = useDefaultProps({ component: "OverflowingTypography", props });
    const [isOverflowed, setIsOverflow] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        ref.current &&
            setIsOverflow(ref.current.scrollWidth > ref.current.clientWidth ||
                ref.current.scrollHeight > ref.current.clientHeight);
    }, [ref.current, children]);
    return (_jsx(Tooltip, { ref: ref, title: children, disableHover: hideTooltip || !isOverflowed, children: _jsx(Typography, { className: clsx([
                overflowingTypographyClasses.root,
                lineClamp && overflowingTypographyClasses["line-clamp"],
                className,
            ]), truncate: truncate ?? !lineClamp, sx: mergeSx({
                overflow: "hidden",
                textOverflow: "ellipsis",
                [`&.${overflowingTypographyClasses["line-clamp"]}`]: {
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: typeof lineClamp === "number" ? lineClamp : undefined,
                },
                breakpoints: typeof lineClamp !== "number"
                    ? {
                        xs: {
                            WebkitLineClamp: lineClamp?.xs,
                        },
                        sm: {
                            WebkitLineClamp: lineClamp?.sm,
                        },
                        md: {
                            WebkitLineClamp: lineClamp?.md,
                        },
                        lg: {
                            WebkitLineClamp: lineClamp?.lg,
                        },
                        xl: {
                            WebkitLineClamp: lineClamp?.xl,
                        },
                    }
                    : undefined,
            }, sx), ...rest, children: children }) }));
});
//# sourceMappingURL=OverflowingTypography.js.map